<template>
  <div class="contentUs">
    <div class="cuBox">
      <ul>
        <li>
          <img src="../../static/common/email.png" alt="">
          <p>
            <span>客服邮箱</span>
            <!-- <span>cs@hkxrpro.com </span> -->
            <span>CS@hkpbgold.com </span>
          </p>
        </li>
        <li>
          <img src="../../static/common/localhost.png" alt="">
          <p>
            <!-- <span>注册地址: 九龙尖沙咀</span>
            <span>营运地址: 九龙尖沙咀</span> -->
            <span>注册地址:Flat 1509, 15/F, Beverley Commercial Centre, 87 Chatham Road South, Tsimshatsui, Kowloon,Hong Kong</span>
            <span>营运地址:Flat 09, 15/F, Beverley Commercial Centre, 87-105 Chatham Road South, Tsimshatsui, Kowloon,Hong Kong</span>
            
          </p>
        </li>
        <li>
          <img src="../../static/common/phone.png" alt="">
          <p>
            <span>联系电话</span>
            <!-- <span>(852)3569 0036</span> -->
            <span>(852)3568 0036</span>
          </p>
        </li>
      </ul>
      <div class="levelLine"></div>
      <div class="tips">
        <ul>
          <li>风险提示：</li>
          <li>祥瑞金业有限公司(以下称：祥瑞金业)提醒您，保证金交易及买卖存在高风险，客户需提前了解所面临的风险，不应该贸然进行投资交易。客户亦应该谨慎考虑自身的投资目标、经验、财务状况及风险承受能力，自行衡量是否适合进行投资。任何保证金交易都具备一定风险，包括（但不限于）杠杆、信用可靠度、有限的法务保护，及可能很大程度影响到货币或货币对价格或交易量的市场动荡因素。</li>
         
          
        </ul>
        <ul>
           <li @click="checkPower(1)" style="cursor: pointer;">应用权限：查看权限</li>
           <li>更新时间：2023年6月27日</li>
          <li @click="checkPower(2)" style="cursor: pointer;">隐私权限：查看权限</li>
          <li>唯一业务识别码 : 75224801</li>
        </ul>
        <ul>
           <li>受限地區：</li>
          <li>祥瑞金业有限公司不為某些司法管轄區的公民/居民提供服務，例如 加拿大、古巴、伊朗、伊拉克、日本、緬甸、朝鮮、蘇丹、敘利亞、土耳其、美國。</li>
        </ul>
      </div>
      <div class="qrcode">
        <img src="../../static/common/qrcode1.png" alt="">
        <div class="qrcode-cont">
          <p>祥瑞金业有限公司</p>
          <p>Prosperity Bullion Limited</p>
          <p>贵金属及宝石交易商注册号码：A-B-23-08-01029</p>
        </div>
      </div>
      <div class="copyRight">COPYRIGHT(©) 2023 祥瑞金业</div>
    </div>
  </div>
</template>

<script>
import router from '../router';

export default {
  name:'Contactus',
  data(){
    return{
      
    }
  },
  methods:{
    checkPower(attr){
      if(attr == 1){
        this.$router.push({
          name:'Application'
        })
        // window.open('https://sem.rlclead.com/agreement/permission');
      }else if(attr == 2){
        // window.open('https://sem.rlclead.com/agreement/privacy');
        this.$router.push({
          name:'Privacy'
        })
      }else{
        this.$router.push({
          name:'Functiong'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .contentUs{
    width: 100%;
    background-color: #121212;
    color: #a9a0a0;
    .cuBox{
      width: 1327px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding-top: 30px;
      ul{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 80px;
        li{
          display: flex;
          justify-content: center;
          align-items: center;
          p{
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            color: #ffffff;
            span{
              line-height: 30px;
            }
            span:nth-child(1){
              font-weight: 600;
              font-size: 14px;
            }
            span:nth-child(2){
              font-size: 13px;
            }
          }
        }
      }
      .levelLine{
        width: 100%;
        height: 1px;
        background-color: #393a3c;
        margin: 15px auto 20px;
      }
      .qrcode {
        display: flex;
        width: 45%;
        padding-left: 232px;
        position: relative;
        top: -40px;
        img {
          width: 125px;
          height: 125px;
        }
        .qrcode-cont {
          padding: 0 0 0 25px;
        }
      }
      .tips{
        width: 100%;
        box-sizing: border-box;
        padding: 0 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ul{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 0 10px;
          li{
            line-height: 28px;
            font-size: 14px;
          }
        }
      }
      .copyRight{
        text-align: center;
        font-size: 13px;
        margin: 15px 0 30px 0;
      }
    }
  }
</style>